import styled from '@emotion/styled';
import { tokens, Text } from '@hotjar/hotsauce';

export const SiteListStyles = {
  Container: styled.div`
    background: ${tokens.color.ui_background};
    border-radius: ${tokens.radius.l};
    border: 1px solid ${tokens.color.ui_border};
    padding: ${tokens.spacer.x2pt5};
    position: relative;
  `,
  Footer: styled.div`
    display: flex;
    flex-direction: column;
    padding-top: ${tokens.spacer.x1pt5};
  `,
  FooterContent: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  `,
  FooterLabel: styled(Text)`
    border-top: 1px solid ${tokens.color.ui_border};
    padding-top: ${tokens.spacer.x2};
    margin-top: ${tokens.spacer.x2};
  `,
  Total: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: end;
  `,
  Price: styled(Text)`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: ${tokens.spacer.x3};
    margin: 0;
    gap: ${tokens.spacer.x0pt5};
  `,
};
